export const ELASTIC_SEARCH_DIRECTORY =
  process.env.NODE_ENV === "production" ? "hallow-app-v3" : "hallow-app-v3-dev";

export const PARISH_SEARCH_DIRECTORY =
  process.env.DOPPLER_PUBLIC_PARISH_SEARCH_DIRECTORY;
